import { useEffect } from "react";
import { ListSkeleton } from "../../skeletons/List";
import { useState } from "react";
import { Container, Typography, Box, Tab, Tabs } from "@mui/material";
import FloatingActionButtons from "../../components/Fab";
import { useDashboardDrawer } from "../../providers/consumers/useDashboardDrawer";
import { useBuilder } from "../../../hooks/useBuilder";
import store, { clear, setFieldState } from "../../store/formStore";
import { useSelector } from "react-redux";
import DataTable from "../../components/Table";
import moment from "moment";
import { AuthHelper } from "../../controllers/AuthHelper";
 import { ServerConfig } from "../../../connectors/Config";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
const ListAccreditamentoDirettore = () => {
    const [certificates, setCertificates] = useState([]);
    const [loading, setLoading] = useState(false);
    const { pushMobileOpen, defaultOpen, addRouter } = useDashboardDrawer();
    const {builder, form, refs} = useBuilder();
    const [value, setValue] = useState(0);
    const [recensioni, setReviews] = useState([]);
    

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const findReviews = async() => {
      let user = await AuthHelper.getUserFromIdToken();

      const res = await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/domanda/direttore/${user.Username}`);
      const json = await res.json();
      setReviews([...json]);
    }
    const elements = useSelector(state => state.elements);

    const columns = [
        { field: 'id', headerName: 'ID', width: 125, headerClassName: 'data-grid-header'},
        { field: 'nome_candidato', headerName: 'Nome e cognome', width: 200, headerClassName: 'data-grid-header' },
        { field: 'ruolo', headerName: 'Ruolo', width: 200, headerClassName: 'data-grid-header' },
        { field: 'modulo_file', headerName: 'Modulo file', width: 200, headerClassName: 'data-grid-header', renderCell: (row) => <a href={row.value} target="_blank">Apri</a> },
        { field: 'curriculum_file', headerName: 'Curriculum file', width: 200, headerClassName: 'data-grid-header', renderCell: (row) => <a href={row.value} target="_blank">Apri</a> },
        { field: 'diploma_file', headerName: 'Diploma file', width: 200, headerClassName: 'data-grid-header', renderCell: (row) => <a href={row.value} target="_blank">Apri</a> },
        { field: 'certificazioni_professionali', headerName: 'Certificazioni professionali', width: 200, headerClassName: 'data-grid-header', renderCell: (row) => <a href={row.value} target="_blank">Apri</a> },
        { field: 'documento_identita_file', headerName: 'Documento identità file', width: 200, headerClassName: 'data-grid-header', renderCell: (row) => <a href={row.value} target="_blank">Apri</a> },
        { field: 'altri_documenti', headerName: 'Altri documenti', width: 200, headerClassName: 'data-grid-header', renderCell: (row) => <a href={row.value} target="_blank">Apri</a> },
        { field: 'createdAt', headerName: 'Data invio', width: 200, headerClassName: 'data-grid-header',valueGetter: (value) => moment(value).format('DD/MM/YYYY') }

    ];

    useEffect(() => {
        findReviews();
        store.dispatch(clear())
        builder('promo.add');
    }, [])

    const handleClick = (data, name = null) => {
        store.dispatch(clear())
        builder('direttori.accreditamento');
        if(data.row){
            Object.keys(data.row).forEach((key) => {
                store.dispatch(setFieldState({name: key, value: data.row[key]}));
            });
        }
        pushMobileOpen(true, 500, name ? name : "Crea Domanda", data.row);

    }

    return (<Container sx={{paddingLeft: 24, paddingRight: 24, minWidth: '100vw', marginTop: '3rem'}}>
    
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Lista domande accreditamento direttori" {...a11yProps(0)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        {loading && <ListSkeleton />}
        {/* {!loading && <DataTable data={certificates} columns={columns} handleClick={handleClick} actions={[
            {type: 'select', name: 'Azioni'}
        ]}/>} */}
        {!loading && <DataTable data={recensioni} columns={columns} actions={[
        {type: 'select', name: 'Azioni'}
        ]}/>}
            <FloatingActionButtons onClick={() => handleClick([], "Crea Domanda")}/>

      </CustomTabPanel>
   
    
    </Container>);
}

export default ListAccreditamentoDirettore;